// extracted by mini-css-extract-plugin
export default {"root":"Vr0ezO05Q5"};